import { render, staticRenderFns } from "./SLanguageIcon.vue?vue&type=template&id=d0c88ac8&scoped=true"
import script from "./sLanguageIcon.ts?vue&type=script&lang=ts&external"
export * from "./sLanguageIcon.ts?vue&type=script&lang=ts&external"
import style0 from "./SLanguageIcon.vue?vue&type=style&index=0&id=d0c88ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c88ac8",
  null
  
)

export default component.exports